'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filter2 = require('./Filter');

var _Filter3 = _interopRequireDefault(_Filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomFilter = (function (_Filter) {
  _inherits(CustomFilter, _Filter);

  /**
   * TODO: throw appropiate errors
   */

  function CustomFilter(id, options) {
    _classCallCheck(this, CustomFilter);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CustomFilter).call(this, id, options));

    if (options.type !== 'custom') {
      throw new Error('The type option for the \'' + id + '\' filter is not \'custom\'');
    }

    if (options.params === undefined) {
      throw new Error('The params option for the \'' + id + '\' filter is undefined');
    }

    if (options.params.function === undefined) {
      throw new Error('The function params option for the \'' + id + '\' filter is undefined');
    } else if (typeof options.params.function !== 'function') {
      throw new Error('The function params option for the \'' + id + '\' filter is not a function');
    }

    _this.filter = options.params.function;
    return _this;
  }

  return CustomFilter;
})(_Filter3.default);

exports.default = CustomFilter;
//# sourceMappingURL=../filters/CustomFilter.js.map